import { createSelector } from '@reduxjs/toolkit';
import type { IUserProfileSearchInfo } from '../../types/userProfile';
import { userProfileClientInfoSelector } from './userProfileClientInfoSelector';

export const userProfileSearchInfoSelector = createSelector(
  [userProfileClientInfoSelector],
  (clientInfo): IUserProfileSearchInfo | null => {
    return clientInfo?.searchInfo || null;
  },
);
